<template>
    <modal :max_width="400" class="modal-message" @close="$emit('close')">
      <div class="px-5 py-16 relative"  v-if="modal_data.sign_up">
        <font-awesome-icon :icon="['fas', 'times']" class="absolute text-brand-grey-light pin-t pin-r mr-4 mt-4 cursor-pointer text-xl z-50" @click="$emit('close')"></font-awesome-icon>

        <p class="mt-2 font-normal text-center">На вашу почту отправлено <a class="text-brand-light font-bold no-underline">письмо</a>.</p>
        <br>
        <p class="font-normal text-center">Пройдите по ссылке в письме,
        чтобы авторизоваться.</p>
      </div>
      <div class="px-5 py-16 relative"  v-if="modal_data.register_complete">
        <font-awesome-icon :icon="['fas', 'times']" class="absolute text-brand-grey-light pin-t pin-r mr-4 mt-4 cursor-pointer text-xl z-50" @click="$emit('close')"></font-awesome-icon>
        <p class="mt-2 font-bold text-center">Поздравляем!</p>
        <br>
        <p class="font-normal text-center">Регистрация прошла успешно.</p>
      </div>
      <div class="px-5 py-16 relative"  v-if="modal_data.recovery_account">
        <font-awesome-icon :icon="['fas', 'times']" class="absolute text-brand-grey-light pin-t pin-r mr-4 mt-4 cursor-pointer text-xl z-50" @click="$emit('recovery_account'); $emit('close')"></font-awesome-icon>
        <p class="mt-2 font-normal text-center">На вашу почту отправлено <a class="text-brand-light font-bold no-underline">письмо</a>.</p>
        <br>
        <p class="font-normal text-center">Пройдите по ссылке в письме,
        чтобы восстановить доступ.</p>
      </div>

    </modal>
</template>

<script>

import ModalMixin from '../../../mixins/modals';
import Modal from '@/views/modals/base-modal';

export default {
  name: 'auth_modal_text',
  props: ['modal_data'],
  components: { Modal },
  mixins: [ModalMixin],
  data() {
    return {

    };
  },
  methods: {

  },
};

</script>

<style scoped>
  .modal-message {
    width: 400px !important;
    min-width: 320px;
  }
</style>
